import React from "react";
import { Input } from "../../hooks/Input";

export const ParameterECDialog = ({ unitId, ecCycleTm, ecCycleTmMin }) => {
    return <div>
        <div className="ph-dialog" draggable="false">
            <div className="row-ph-dialog ph-level-row">
                <p>Пауза доз. (мин)</p>
                <Input
                    value={ecCycleTm}
                    min={ecCycleTmMin}
                    mode={1}
                    deviceId={unitId}
                    ckey={'ecCycleTm'}
                />
            </div>
        </div>
    </div>
}
